import { gql } from "graphql-tag";
import { PROMOTION_FIELDS } from "./Fragments";

export const CREATE_PROMOTION = gql`
    mutation CreatePromotion($input: PromotionInput!) {
        create_promotion(promotion: $input) {
            ...PromotionFields
        }
    }
    ${PROMOTION_FIELDS}
`;

export const UPDATE_PROMOTION = gql`
    mutation UpdatePromotion($input: PromotionInput!) {
        update_promotion(promotion: $input) {
            ...PromotionFields
        }
    }
    ${PROMOTION_FIELDS}
`;

export const CREATE_SERVICE_PROMOTION = gql`
    mutation CreateServicePromotion($input: ServicePromotionInput!) {
        create_service_promotion(promotion: $input) {
            ...PromotionFields
        }
    }
    ${PROMOTION_FIELDS}
`;

export const UPDATE_SERVICE_PROMOTION = gql`
    mutation UpdateServicePromotion($input: ServicePromotionInput!) {
        update_service_promotion(promotion: $input) {
            ...PromotionFields
        }
    }
    ${PROMOTION_FIELDS}
`;

export const DELETE_PROMOTION = gql`
    mutation DeletePromotion($id: Int!) {
        delete_promotion(id: $id)
    }
`;

export default { CREATE_PROMOTION, UPDATE_PROMOTION, CREATE_SERVICE_PROMOTION, UPDATE_SERVICE_PROMOTION, DELETE_PROMOTION };
